import React from "react";
import PropTypes from "prop-types";
import CustomPopup from "../../../Common/components/CustomPopup/CustomPopup";
import t from "../../../Common/utils/translation/translator";
import { colKeyToName } from "../../../Retrofit/utils/CorrespondingCrossComponent/cccUtils";
import prettyPrint from "../../../Retrofit/utils/CorrespondingCrossComponent/prettyPrint";

const MobileBundleInfoPopup = ({ solution, detailRef, opened, onClose }) => {
  const refInfos = [
    {
      groupName: "drive",
      infos: [
        "driveRangeOfProduct",
        "driveType",
        "driveComponentType",
        "switchingFreq",
        "format",
        "current",
        "driveSupplyVoltage",
        "nbPhases",
        "interface",
        "nominalPower",
        "driveOutputCurrent3SPeak",
        "lineCurrent",
        "driveWidth",
        "driveHeight",
        "driveDepth",
        "driveNetWeight"
      ]
    },
    {
      groupName: "motor",
      infos: [
        "motorComponentType",
        "motorType",
        "flangeSize",
        "numberOfStacks",
        "nominalTorqueOfMotor",
        "continuousStallTorque",
        "peakStallTorque",
        "nominalSpeedOfMotor",
        "maximumMechanicalSpeed",
        "length",
        "holdingBrake",
        "motorSupplyVoltage",
        "shaftEnd",
        "shaftDiameter",
        "shaftLength",
        "ipProtections",
        "motorEncoder",
        "connector",
        "inertiaMotor",
        "motorWeight",
        "continuousStallCurrent",
        "speedFeedbackResolution",
        "motorOutputCurrent3SPeak",
        "holdingBrake"
      ]
    },
    {
      groupName: "gearbox",
      infos: [
        "gearboxComponentType",
        "gearboxType",
        "gearboxFamily",
        "externalDiameter",
        "inputDiameter",
        "gearboxRatio",
        "gearboxEfficiency",
        "gearboxTorsionalBacklash",
        "shaftMomentOfInertia",
        "gearboxNetWeight",
        "gearboxLength",
        "continuousOutputTorque",
        "maximumOutputTorque",
        "gearboxIpDegreeOfProtection"
      ]
    },
    {
      groupName: "adaptation_kit",
      infos: [
        "adaptationKitComponentType",
        "separatePartDestination",
        "adaptationKitLength",
        "kitComposition",
        "kitFlangeSize",
        "adaptationKitWeight"
      ]
    }
  ];

  let reference;
  switch (JSON.stringify(detailRef)) {
    case JSON.stringify(solution.driveReference):
      reference = "drive";
      break;
    case JSON.stringify(solution.motorReference):
      reference = "motor";
      break;
    case JSON.stringify(solution.gearboxReference):
      reference = "gearbox";
      break;
    default:
      reference = "adaptation_kit";
  }

  const group = refInfos.filter((i) => i.groupName === reference);

  return (
    <CustomPopup opened={opened} onClose={onClose}>
      <div className="!text-left text-xl font-bold text-logoGreen">
        {`${t(`msizer.ui.${reference}`)} - ${detailRef}`}
      </div>
      <div className="divide-y max-h-[77vh]">
        {group[0].infos.map(
          (i) =>
            solution[i] && (
              <div className="flex justify-between py-4">
                {/* TODO : find the right formula to get the labels */}
                <span className="font-bold text-left">{colKeyToName(i)}</span>
                <span className="text-right">{prettyPrint(i, solution[i])}</span>
              </div>
            )
        )}
      </div>
    </CustomPopup>
  );
};

MobileBundleInfoPopup.propTypes = {
  solution: PropTypes.object,
  detailRef: PropTypes.string,
  opened: PropTypes.bool,
  onClose: PropTypes.func
};

MobileBundleInfoPopup.defaultProps = {
  solution: {},
  detailRef: "",
  opened: false,
  onClose: undefined
};

export default MobileBundleInfoPopup;
